import { newRelicJSError } from "./analytics/new_relic_helper";

export function twitterTrackLead() {
    try {
        twttr.conversion.trackPid('nyxo8', { tw_sale_amount: 0, tw_order_quantity: 0 });
    } catch (err) {
        const error = "Error firing Twitter Event Tag: " + err;
        newRelicJSError(error);
        console.error(error);
    }
}
